import { useState } from 'react';

const useTheme = () => {
  const [state] = useState({
    buttonVariant: 'outline-dark',
  });

  return [state];
};

export default useTheme;
